/*
@desc 名称：openCustomWebview
	功能：打开一个通用webview

验证方式：离线验证 需要verify
兼容版本：ANDROID V6.5.0及以上版本

开放状态：未开放
开放范围：白名单

@param {
	"url":"xxxxx" 
	"orientation":"horizontal"
	"fullscreen":true
	"finish_recent_webview":"1"
	"disable_swipe_back":"1"
}
*/
import wxBridge from '../jsbridge/jsbridge_base.js';

wxBridge.openCustomWebview = wxBridge.openCustomWebview || function(param, callback) {
    wxBridge.invoke('openCustomWebview', param, callback);
};

export default wxBridge;

export const {
    openCustomWebview
} = wxBridge;
